import appStore from 'store'
import api from './api'
import { PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
    updateBelongPagination: PAGINATION,
    updateBelongList: [],
    updateBelongTotal: 0,
    orderBy: null,
    addUseVisible: false,
    countryCodeList: [],
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice()
      state.totalCount = payload.totalCount
    },
    setUpdateBelongList(state, payload) {
      state.updateBelongList = payload.records
      state.updateBelongTotal = payload.total
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setUpdateBelongPagination(state, payload) {
      state.updateBelongPagination = payload
    },
    setQueryType(state, payload) {
      state.queryType = payload
    },
    setOrderBy(state, payload) {
      state.orderBy = payload
    },
    setAddUser(state, payload) {
      state.addUseVisible = payload
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          commit('setUserList', res.data)
        }
      })
    },
    addTop({ commit }, data) {
      return api.addTop(data)
    },
    addPartner({ commit }, data) {
      return api.addPartner(data)
    },
    modifyPartner({ commit }, data) {
      return api.modifyPartner(data)
    },
    updateAffaires({ commit }, data) {
      return api.updateAffaires(data)
    },
    movePartner({ commit }, data) {
      return api.movePartner(data)
    },
    getUserData({ commit }, data) {
      return api.getUserData(data)
    },
    upgradeRate({ commit }, data) {
      return api.upgradeRate(data)
    },
    updatePsd({ commit }, data) {
      return api.updatePsd(data)
    },
    forbidden({ commit }, data) {
      return api.forbidden(data)
    },
    updateBelong({ commit }, query = {}) {
      commit('setUpdateBelongPagination', {
        page: query.page,
        size: query.size,
      })
      api.updateBelong(query).then((res) => {
        if (res.code == 0) {
          commit('setUpdateBelongList', res.data)
        }
      })
    },
    addTopRemark({ commit }, data) {
      return api.addTopRemark(data)
    },
    addUser({ commit }, data) {
      return api.addUser(data)
    },
    fetchCoutryCode({ commit }) {
      return api.coutryCode().then(({ data }) => {
        commit('setCountryCodeList', data)
      })
    },
  },
}

appStore.registerModule('partnerList', store)
